(function () {
  var mixin = {
    months: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    Init: function () {
      for (var element in generaxion) {
        var section = generaxion[element];
        mixin[section](element);
      }
    },
    Facebook: function (id) {
      var container = document.querySelector("[data-section-id='" + id + "']"),
        amount = container.dataset.amount;
        height = container.dataset.height,
      //ANDPANTS FB ID: 157149134378148
     mixin.Get("https://facebook-api.generaxion.tech/umbraco/surface/facebook/GetInstagramFeed?facebookId=233134650064134&amount=" + amount, function (res) {
       	var posts = JSON.parse(res);
        
        posts.forEach(function (post) {
          var div = document.createElement('div'),
              img = post.media_type == 'VIDEO' ? post.thumbnail_url : post.media_url;
          div.classList.add('instagram-grid__item');
          div.innerHTML = "<div class='image' style='height: "+ height +"px;'>\
                            <a href="+ post.permalink +" target='_blank'>\
                            	<img style='height: "+ height +"px;' class='lazyload' data-srcset='"+ img +"' />\
                            </a>\
							<span class='reactions'><i class='likes'>" + post.like_count + "</i><i class='comments'>" + post.comments_count + "</i></span>\
                          </div>";
          container.querySelector('.instagram-grid').appendChild(div);
        });   
      });
    },
    FormatDate: function (date) {
      var d = new Date(date);
      return d.getDate() + ". " + mixin.months[d.getMonth()] + ".";
    },
    LogoListSlider: function (id) {
      var container = document.querySelector("[data-section-id='" + id + "']"),
        logoList = container.querySelector(".logo-list");

      $(logoList).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        accessibility: true,
        autoplay: true,
        arrows: true,
        speed: 500,
        swipe: true,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },{
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
      
    },
    Get: function (url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          callback(this.response);
        }
      };
      xhr.open("GET", url, true);
      xhr.send();
    }
  }
  document.addEventListener("DOMContentLoaded", function() {
    mixin.Init();
  });
})()

document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelector(".Showfilters")){
    

  const toggleFilterBtn = document.querySelector(".Showfilters");
  const filterSection = document.querySelector(".cc-filters__items");

  toggleFilterBtn.addEventListener("click", function() {
    filterSection.classList.toggle("hidden");
    document.querySelector(".closeOverlay").classList.add("activeOverlay");
  });

   
   var modal = document.querySelector(".cc-filters__items");

  // Function to open the modal
  function openModal() {
    modal.classList.remove("hidden");
    // Add event listener to close the modal when clicking outside of it
   document.querySelector(".closeOverlay").classList.add("activeOverlay");
  }

  // Function to close the modal
  function closeModal() {
    modal.classList.add("hidden");
    // Remove the event listener to avoid unintended closure of the modal
       document.querySelector(".closeOverlay").classList.remove("activeOverlay");
  }


document.querySelector(".closeOverlay").addEventListener("click", function(){
        modal.classList.add("hidden")
        document.querySelector(".closeOverlay").classList.remove("activeOverlay");
   })
   
     document.querySelector(".cc-filters__close").addEventListener("click", function(){
        modal.classList.add("hidden")
       document.querySelector(".closeOverlay").classList.remove("activeOverlay");
     
   })
    }
 });
if(document.querySelector(".cc-filters__items .js-close-filters")) {
  
document.querySelector(".cc-filters__items .js-close-filters").addEventListener("click", function(){
  
     document.querySelector(".cc-filters__items").classList.add("hidden");
    document.querySelector(".closeOverlay").classList.remove("activeOverlay");
})
}

/* Scroll gradiant til underkategorier */
document.addEventListener('DOMContentLoaded', function () {
  var subcollections = document.querySelectorAll('.subcollection');

  subcollections.forEach(function (subcollection) {
    var list = subcollection.querySelector('.subcollection-list');

    if (!list) return;

    function updateGradients() {
      var scrollLeft = list.scrollLeft;
      var maxScrollLeft = list.scrollWidth - list.clientWidth;

      if (maxScrollLeft > 1) {
        subcollection.classList.add('can-scroll');
      } else {
        subcollection.classList.remove('can-scroll');
      }

      if (scrollLeft > 1) {
        subcollection.classList.add('is-scrolled');
      } else {
        subcollection.classList.remove('is-scrolled');
      }

      if (scrollLeft >= maxScrollLeft - 1) {
        subcollection.classList.add('is-at-end');
      } else {
        subcollection.classList.remove('is-at-end');
      }
    }

    updateGradients();

    list.addEventListener('scroll', updateGradients);
    window.addEventListener('resize', updateGradients);
  });
});

/*
function moveLablyBadges() {
  const cards = document.querySelectorAll('.product-block');
  const badges = document.querySelectorAll('._lably_item_');

  if (!cards.length || !badges.length) return;

  cards.forEach(function (card, index) {
    const hoverImages = card.querySelector('.hover-images');
    const badge = badges[index];

    if (!hoverImages || !badge) return;

    if (!hoverImages.querySelector('._lably_item_')) {
      hoverImages.prepend(badge);
    } else if (badge.parentElement !== hoverImages) {
      hoverImages.prepend(badge);
    }
  });
}

function initLablyFix() {
  moveLablyBadges();

  [300, 800, 1500, 2500, 4000].forEach(function (delay) {
    setTimeout(moveLablyBadges, delay);
  });
}

document.addEventListener('DOMContentLoaded', initLablyFix);
window.addEventListener('load', initLablyFix);

const lablyObserver = new MutationObserver(function () {
  moveLablyBadges();
});

lablyObserver.observe(document.body, {
  childList: true,
  subtree: true
});
*/